import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Text } from "@zillow/constellation-10";
import { migrateColorToken } from "../../utils/token-migration/v8-to-v10.esm.js";
const TextInline = ({
  fontColor,
  fontSize,
  fontWeight,
  fontFamily,
  children,
  ...rest
}) => {
  const color = migrateColorToken(fontColor) || "inherit";
  const textStyles = css.raw({
    color,
    fontSize: fontSize || "inherit",
    fontWeight: fontWeight || "inherit",
    fontFamily: fontFamily || "inherit"
  });
  return /* @__PURE__ */ jsx(Text, { css: textStyles, ...rest, children });
};
export {
  TextInline as default
};
